import { render, staticRenderFns } from "./ModifyPassword.vue?vue&type=template&id=ce9fbc60&scoped=true&"
import script from "./ModifyPassword.vue?vue&type=script&lang=js&"
export * from "./ModifyPassword.vue?vue&type=script&lang=js&"
import style0 from "./ModifyPassword.vue?vue&type=style&index=0&id=ce9fbc60&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce9fbc60",
  null
  
)

export default component.exports